module.exports = "/static/js/7ea3a6d428136b87ab95ee89b6e956e7.png";